import { render, staticRenderFns } from "./BonusSectionSetting.vue?vue&type=template&id=6ca9b139&scoped=true&"
import script from "./BonusSectionSetting.vue?vue&type=script&lang=ts&"
export * from "./BonusSectionSetting.vue?vue&type=script&lang=ts&"
import style0 from "./BonusSectionSetting.vue?vue&type=style&index=0&id=6ca9b139&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ca9b139",
  null
  
)

export default component.exports